import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopupAction } from '../../services/edocs-utils.service';

@Component({
  selector: 'bepatient-edocs-popover',
  templateUrl: './edocs-popover.component.html',
  styleUrls: ['./edocs-popover.component.scss'],
  standalone: false
})
export class EdocsPopoverComponent {
  @Input() actions: PopupAction[];
  @Output() applyAction = new EventEmitter<PopupAction>();
}
